import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./assets/style/output.css";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import AdminLogin from "./pages/Dashboard/AdminLogin";
import Assignment from "./pages/Dashboard/Assignment";
import AssignmentMark from "./pages/Dashboard/AssignmentMark";
import Dashboard from "./pages/Dashboard/Dashboard";
import Quizzes from "./pages/Dashboard/Quizzes";
import Videos from "./pages/Dashboard/Videos";
import CoursePlayer from "./pages/StudentPortal/CoursePlayer";
import Leaderboard from "./pages/StudentPortal/Leaderboard";
import Quiz from "./pages/StudentPortal/Quiz";
import StudentLogin from "./pages/StudentPortal/StudentLogin";
import StudentRegistration from "./pages/StudentPortal/StudentRegistration";

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <div>Checking Authentication.... </div>
  ) : (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute role={"student"}>
              <StudentLogin />
            </PublicRoute>
          }
        />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route
          path="/quiz/:id"
          element={
            <PrivateRoute role={"student"}>
              <Quiz />
            </PrivateRoute>
          }
        />
        <Route
          path="/course-player"
          element={
            <PrivateRoute role={"student"}>
              <CoursePlayer />
            </PrivateRoute>
          }
        />
        <Route
          path="/registration"
          element={
            <PublicRoute role={"student"}>
              <StudentRegistration />
            </PublicRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <PublicRoute role={"admin"}>
              <AdminLogin />
            </PublicRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute role={"admin"}>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/assignment"
          element={
            <PrivateRoute role={"admin"}>
              <Assignment />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/assignment-mark"
          element={
            <PrivateRoute role={"admin"}>
              <AssignmentMark />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/quizzes"
          element={
            <PrivateRoute role={"admin"}>
              <Quizzes />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/videos"
          element={
            <PrivateRoute role={"admin"}>
              <Videos />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
